import React, { Component } from "react";
import { connect } from "react-redux";
import { changeLocInfoAction, changeDistAction, setUserLicenseAction, setModeleTableAction } from "../redux/app/actions";
import { changeIdAction, changePassAction, changeIsErrAction, changeIsLoginAction } from "../redux/user/actions";

import App from "./App";

const mapStateToProps = (state) => {
    return {
        id: state.userReducer.id,
        pass: state.userReducer.pass,
        isErr: state.userReducer.isErr,
        isLogin: state.userReducer.isLogin,
        userLicense: state.appReducer.userLicense,
    };
};

/*
 * 半角英数字か判定
 * @param {string} str 文字列
 * @return{array|null}
 * @since hara 2022-04-04
 */
export const isHalfAn = (str) => {
    return str.match(/^[A-Za-z0-9]*$/);
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.changeId = this.changeId.bind(this);
        this.changePass = this.changePass.bind(this);
        this.ban = this.ban.bind(this);
        this.disabBtn = this.disabBtn.bind(this);
        this.login = this.login.bind(this);
    }

    /*
     * ユーザーID変更
     * @param {Event} e イベント情報
     * @since hara 2022-04-04
     */
    changeId(e) {
        this.props.dispatch(changeIdAction(e.target.value));
    }

    /*
     * パスワード変更
     * @param {Event} e イベント情報
     * @since hara 2022-04-04
     */
    changePass(e) {
        this.props.dispatch(changePassAction(e.target.value));
    }

    /*
     * デフォルト動作キャンセル
     * @since hara 2022-04-04
     */
    ban(e) {
        e.preventDefault();
    }

    /*
     * ログインボタン非活性
     * @since hara 2022-04-04
     */
    disabBtn(e) {
        //ボタンを非活性にする
        this.props.dispatch(changeIsErrAction(true));
        setTimeout(() => {
            this.props.dispatch(changeIsErrAction(false));
        }, 5000);
    }

    /*
     * ログイン
     * @since hara 2022-04-04
     */
    login() {
        //入力値確認
        if (this.props.id === "" || this.props.pass === "") {
            alert("未入力の項目があります。");
            return;
        }
        if (!isHalfAn(this.props.id) || !isHalfAn(this.props.pass)) {
            alert("半角英数字以外の文字が含まれます。");
            return;
        }
        //idがsapporoに限り開発版パスワードを許す
        let pass;
        if (this.props.id == "sapporo") {
            if (this.props.pass.substr(6, 10) == "demo" && this.props.pass.length == 10) {
                pass = this.props.pass.substr(0, 6);
            } else {
                pass = this.props.pass;
            }
        } else {
            pass = this.props.pass;
        }

        //recaptchaによるトークン発行後、サーバーに送信
        //        window.grecaptcha.ready(() => {
        //            window.grecaptcha.execute(CONST.RECAP_KEY, {action: 'login'}).then(token => {
        const data = {
            id: this.props.id,
            pass: pass,
            //                    token: token
        };

        fetch("/api/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((rslt) => {
                this.props.dispatch(setUserLicenseAction(rslt.user));
                this.props.dispatch(setModeleTableAction(10));
                this.props.dispatch(changeIsLoginAction(rslt.succ));
                if (!rslt.succ) {
                    alert("IDまたはパスワードが違います。");
                    this.disabBtn();
                }
            })
            .catch((err) => {
                console.log(err.message);
            });
        //            });
        //        });
    }

    /*
     * ログイン状態取得
     * @since hara 2022-04-11

    getLoginState(){
        fetch('/api/getLoginState')
            .then(res => res.json())
            .then(rslt => {
                this.props.dispatch(changeIsLoginAction(rslt.isLogin));
            });
    }

    componentDidMount() {
        this.getLoginState();
    }
       */

    render() {
        return (
            <React.Fragment>
                {this.props.isLogin ? (
                    <App />
                ) : (
                    <div className="Login l-center">
                        <div className="Login__inner l-column">
                            <div className="l-row">
                                <span className="Login__logoMark icon-logo">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                    <span className="path3"></span>
                                    <span className="path4"></span>
                                </span>
                                <span className="Login__logoText icon-gmai"></span>
                            </div>
                            <div className="l-mtM"></div>
                            <input className="loginText l-mtM" type="text" name="id" placeholder="IDを入力してください" onChange={this.changeId} />
                            <input
                                className="loginText l-mtM"
                                type="password"
                                name="pass"
                                placeholder="パスワードを入力してください"
                                onChange={this.changePass}
                                onCopy={this.ban}
                                onPaste={this.ban}
                                onContextMenu={this.ban}
                            />
                            <div className={this.props.isErr ? "disabled" : ""}>
                                <button className="loginBtn l-mtM" data-action="login" onClick={this.login}>
                                    ログイン
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default connect(mapStateToProps)(Login);
